import { SVGProps, memo } from 'react';

const DocumentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.875 21C5.39175 21 5 20.5971 5 20.1V3.9C5 3.40294 5.39175 3 5.875 3H13.4586L19 9.51885V20.1C19 20.5971 18.6082 21 18.125 21H5.875ZM6.57483 18.8802C6.57483 19.1563 6.79869 19.3802 7.07483 19.3802H17.4252V10.3292H14.3336C13.4155 10.3292 12.6708 9.56323 12.6708 8.61885V5.11982C12.6708 4.84368 12.4469 4.61982 12.1708 4.61982H7.07483C6.79869 4.61982 6.57483 4.84368 6.57483 5.11982V18.8802ZM14.2456 8.61885C14.2456 8.66853 14.2853 8.7085 14.3336 8.7085H16.2186L14.2456 6.38643V8.61885Z'
      fill='black'
      fill-opacity='0.56'
    />
  </svg>
);

export default memo(DocumentIcon);
